function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_666",
  "data-name": "Group 666",
  transform: "translate(-1035 -1033)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(1035 1033)"
}, React.createElement("circle", {
  id: "Icon.BG",
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#ffe2e6"
})), React.createElement("g", {
  id: "iconfinder_42-box_4243288",
  transform: "translate(1045 1043)"
}, React.createElement("path", {
  id: "Path_361",
  "data-name": "Path 361",
  d: "M11.667,21a2.667,2.667,0,1,1-5.333,0H1v5.333H17V21Z",
  transform: "translate(0 -9.333)",
  fill: "none",
  stroke: "#ff6565",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), React.createElement("path", {
  id: "Path_362",
  "data-name": "Path 362",
  d: "M1,11.667,3.133,1H14.867L17,11.667",
  fill: "none",
  stroke: "#ff6565",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/out-of-stock.fb21d868.svg";
export { SvgComponent as ReactComponent };